import React, { useState, useEffect } from 'react';
import { Box, Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import videoSrc from './../../assets/images/nyc_flyover_slow.mp4';

function LandingPage({ onSignInClick, onSignUpClick }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const [fontSize, setFontSize] = useState('60px');
  const [fontSizeContactsLarge, setfontSizeContactsLarge] = useState('25px');
  const [fontSizeContactsMedium, setfontSizeContactsMedium] = useState('20px');
  const [fontSizeContactsSmall, setfontSizeContactsSmall] = useState('15px');
  const [isPhone, setIsPhone] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => setIsPhone(window.innerWidth <= 600);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth < 700) {
        setFontSize('8vw');
        setfontSizeContactsLarge('4vw');
        setfontSizeContactsMedium('3.3vw');
        setfontSizeContactsSmall('2.5vw');
      } else {
        setFontSize('60px');
        setfontSizeContactsLarge('25px');
        setfontSizeContactsMedium('20px');
        setfontSizeContactsSmall('15px');
      }
    };
    window.addEventListener('resize', updateFontSize);
    updateFontSize();
    return () => window.removeEventListener('resize', updateFontSize);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const section = document.getElementById(hash.substring(1));
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  const signUpButtonStyle = {
    backgroundColor: 'white',
    zIndex: '1',
    height: '50px',
    width: '200px',
    color: theme.palette.ke.dark_blue,
    '&:hover': {
      backgroundColor: theme.palette.ke.medium_blue,
      color: 'white'
    }
  };

  return (
    <Box style={{ border: 'none', position: 'relative', overflow: 'auto' }}>
      {/* Hero */}
      <Box style={{
        border: 'none',
        height: 'calc(100vh - 62px - 24px - 2px)',
        minHeight: '450px',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <Box style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px',
        }}>
          <h1 style={{
            color: 'white',
            fontSize: fontSize,
            fontWeight: '300',
            fontFamily: 'Alata',
            whiteSpace: 'nowrap',
          }}>Alpha-Pilot.ai</h1>
          <Button variant="contained" sx={signUpButtonStyle} onClick={() => navigate('/signup')}>
            Register
          </Button>
          <span style={{
            color: 'white',
            fontSize: '0.95rem',
            fontFamily: 'Alata',
            fontWeight: '300',
            textAlign: 'center',
          }}>
            Alpha-Pilot.ai is a project of{' '}
            <a
              href="https://www.kesslerenergy.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'white', textDecoration: 'underline' }}
            >
              Kessler Energy, LLC
            </a>
          </span>
        </Box>
        {isPhone ? (
          <Box style={{
            backgroundColor: theme.palette.ke.dark_blue,
            width: '100%',
            height: '100%',
            position: 'absolute',
            zIndex: '-1',
            top: '0',
            left: '0'
          }} />
        ) : (
          <video autoPlay loop muted playsInline style={{ width: '100%', height: '100%', objectFit: 'cover', top: '0', left: '0', zIndex: '-1', position: 'absolute' }}>
            <source src={videoSrc} type="video/mp4" />
          </video>
        )}
      </Box>

      {/* In-development notice */}
      <Box id='description' style={{
        position: 'relative',
        backgroundColor: '#3498db',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8vh 5vw',
      }}>
        <p style={{
          color: 'white',
          fontSize: fontSizeContactsMedium,
          fontWeight: '300',
          fontFamily: 'Alata',
          width: '80%',
          maxWidth: '820px',
          textAlign: 'center',
          lineHeight: '1.6',
        }}>
          Alpha-Pilot.ai is a research and data technology project under development by
          Kessler Energy, LLC. For information about Kessler Energy, LLC, please visit{' '}
          <a
            href="https://www.kesslerenergy.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'white', textDecoration: 'underline' }}
          >
            kesslerenergy.com
          </a>.
        </p>
      </Box>

      {/* Contact Us */}
      <Box id='contact-us' style={{
        position: 'relative',
        backgroundColor: '#ecf0f1',
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '4vh 0',
      }}>
        <h2 id='contact-us-header' style={{
          fontSize: fontSizeContactsLarge,
          fontWeight: '300',
          fontFamily: 'Alata',
          width: '70%',
          textAlign: 'center',
        }}>CONTACT US</h2>
        <a href="tel:713-225-6400" style={{ textDecoration: 'none', color: 'inherit' }}>
          <p id='phone' style={{ fontSize: fontSizeContactsMedium }}>713-225-6400</p>
        </a>
        <Box style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          boxSizing: 'border-box',
        }}>
          <Box id='mailing-address' style={{
            padding: '0 3vw 3vw 5vw',
            boxSizing: 'border-box',
          }}>
            <h3 style={{ fontSize: fontSizeContactsMedium }}>MAILING ADDRESS</h3>
            <p style={{ fontSize: fontSizeContactsSmall }}>1415 S Voss Rd, Ste 110-421</p>
            <p style={{ fontSize: fontSizeContactsSmall }}>Houston, TX 77057</p>
          </Box>
          <Box id='corporate-office' style={{
            padding: '0 2vw 3vw 3vw',
            boxSizing: 'border-box',
          }}>
            <h3 style={{ fontSize: fontSizeContactsMedium }}>CORPORATE OFFICE</h3>
            <p style={{ fontSize: fontSizeContactsSmall }}>108 Wild Basin Rd. South, Ste 250</p>
            <p style={{ fontSize: fontSizeContactsSmall }}>Austin, TX 78746</p>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LandingPage;
